// extracted by mini-css-extract-plugin
export default {"editModal":"EditModal_editModal__f-jzp","editModalInput":"EditModal_editModalInput__wHIdB"};